import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { theme } from "./theme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
);

// ---- Service Worker: robusto y no bloqueante ----
(function setupSW() {
  if (!("serviceWorker" in navigator)) return;
  // Interruptor de emergencia para descartar el SW si algo va mal
  try {
    if (localStorage.getItem("DISABLE_SW") === "1") return;
  } catch {}

  // Importante: usa ruta absoluta para evitar PUBLIC_URL raros
  const swUrl = "/sw.js";

  const wireFlush = () => {
    // Evita duplicar wiring
    if (window.__swFlushWired) return;
    window.__swFlushWired = true;

    const flush = () => {
      try {
        navigator.serviceWorker.controller?.postMessage("FLUSH_OUTBOX");
      } catch {}
    };

    window.addEventListener("online", flush);
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) flush();
    });
    // “latido” suave por si el evento online no llega
    window.__swFlushInterval = window.setInterval(flush, 30000);
    flush(); // primer intento
  };

  const onRegistered = (reg) => {
    console.log("SW registrado:", reg.scope);

    // Ejecuta cuando el SW ya controla esta página
    const whenControlled = () => {
      if (!navigator.serviceWorker.controller) return;

      // Cableado de flush (ya evita duplicados con __swFlushWired)
      wireFlush();

      // Background Sync: solo ahora (cuando ya hay controller)
      if ("sync" in reg) {
        try {
          reg.sync.register("outbox-sync");
        } catch {}
      }

      // No seguir escuchando más cambios de controller
      navigator.serviceWorker.removeEventListener("controllerchange", whenControlled);
    };

    if (navigator.serviceWorker.controller) {
      // Ya controla: podemos ir directos
      whenControlled();
    } else {
      // Primera carga: espera a que pase a "controlled"
      navigator.serviceWorker.addEventListener("controllerchange", whenControlled);
    }
  };

  const onError = (err) => {
    console.error("Fallo al registrar el SW:", err);
  };

  // Registra justo tras load para no interferir con la app
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(swUrl).then(onRegistered).catch(onError);
  });
})();
